'use strict';

angular.module('cgmemApp')
  .controller('AccountsCtrl', function ($scope, $rootScope, $state, $q, $http, $filter, $log, AppConfig, WorkingAccount, User) {
		$scope.filterText = "";

		$scope.onlyPaid = false;
		$scope.onlyWithBalance = false;
		$scope.onlyNotBondPaid = false;
		$scope.includeInactive = false;
		$scope.onlyNonReturning = false;
		$scope.notes = false;
		
		$scope.advancedSearch = false;
		
		$scope.accounts = [];
		$scope.loaded = false;
		
		var appConfig = {};

		// Pagination
		$scope.itemCountOpts = [{ label: "10/page", count: 10 }, { label: "20/page", count: 20 },
		{ label: "100/page", count: 100 }, { label: "1000/page", count: 1000 }];

		$scope.currentPage = 0;
		$scope.pageSize = 20;
		$scope.filteredAccounts = [];
		$scope.pagedAccounts = [];
		
		$q.all([AppConfig.get(), $http.get('/api/accounts')])
		.then(function(d) {
			appConfig = d[0];
			$scope.appConfig = appConfig;
			var accts = d[1].data;
				_.forEach(accts, function(a) {
					a.surnames = _(a.members).filter({deleted: false}).map('lastName').uniq().toString();
				})
				$scope.accounts = _.sortBy(accts, 'accountNumber');
				$scope.currentPage = 1;
		})
		.catch(function(err) {
			$log.error("AccountsCtrl: get all accounts returned an error:",err);
			$rootScope.$emit('generalAlert', "Error retrieving accounts: "+err.message);
		})
		.finally(function() {
			$scope.loaded = true;
		});


		var filterAccounts = function() {
			var p1 = _.filter($scope.accounts, function(a) {
				if($scope.advancedSearch)
					return (
						(!$scope.onlyPaid || (a.sMS && a.sMS[appConfig.season] && a.sMS[appConfig.season].length)) &&
						(!$scope.onlyWithBalance || (a.balance)) &&
						(!$scope.onlyNotBondPaid || (a.accountType == "NEW")) &&
						($scope.includeInactive || (a.active)) &&
						(!$scope.onlyNonReturning || (a.sMS && !a.sMS[appConfig.season] && a.sMS[appConfig.season - 1])) &&
						(!$scope.notes || (a.note && a.note.length))
					);
				else
					return a.active;
			});
			return $filter('filter')(p1, $scope.filterText);
			
		}
		
		$scope.$watchGroup(['currentPage', 'pageSize', 'onlyPaid', 'onlyWithBalance', 'onlyNotBondPaid', 'includeInactive', 'onlyNonReturning', 'filterText', 'notes'], function () {
			var start = ($scope.currentPage - 1) * $scope.pageSize;
			$scope.filteredAccounts = filterAccounts($scope.accounts);
			$scope.pagedAccounts = _.slice($scope.filteredAccounts, start, start + $scope.pageSize);
		});


		$scope.go = function($event, accountId) {
			if($event.ctrlKey && User.isInGroup("admins")) {
				WorkingAccount.get(accountId)
				.then(function() {
					$state.go('authenticated.profile')
				});		// FIX: error check
			} else {
				$state.go('authenticated.accountView', {id: accountId, previousState: "authenticated.accounts"})
			}
		}
  })
  .controller('AddAccountCtrl', function ($scope, $rootScope, $state, $q, $http, Account, Member) {
		$scope.account = new Account();
		$scope.member = new Member();
		
		$scope.loading = false;
		
		$scope.member.adult = true;
		$scope.member.senior = false;
		$scope.member.gender = 'M';
		$scope.member.emailLists = ["club"];
		$scope.member.canLogin = true;
		$scope.member.ageBand = 'adult'
		
		$scope.account.accountType="NEW";
		
		$scope.ok22 = function() {
			$state.go("authenticated.accountEdit", {new: true});
		}
		
		$scope.ok = function() {
			if(!$scope.member.firstName || !$scope.member.lastName) {
				$rootScope.$emit('generalAlert', "First and last name are required");
				return;
			}
			
			if(!$scope.member.email) {
				$rootScope.$emit('generalAlert', "Valid Email address is required");
				return;
			}
		
			$scope.loading = true;
			$rootScope.$emit('generalAlert', "");
			$scope.account.$save()
			.then(function() {
				$scope.member.accountId = $scope.account._id;
				return $scope.member.$save();
			}, function(res) {
				$rootScope.$emit('generalAlert', 'Account creation failed: '+res.data);
				$q.reject();
			})
			.then(function() {
				$state.go('authenticated.accounts')
			}, function(res) {
				$rootScope.$emit('generalAlert', 'Account created, but member not: '+res.data);
				$state.go('authenticated.accounts');
				$q.reject();
			})
			.finally(function() {
				$scope.loading = false;
			});
		}
		$scope.cancel = function() {
			$rootScope.$emit('generalAlert', "");
			$state.go('authenticated.accounts')
		};	
  });
